import { render, staticRenderFns } from "./xxcj.vue?vue&type=template&id=104cc21e&scoped=true"
import script from "./xxcj.vue?vue&type=script&lang=js"
export * from "./xxcj.vue?vue&type=script&lang=js"
import style0 from "./xxcj.vue?vue&type=style&index=0&id=104cc21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104cc21e",
  null
  
)

export default component.exports